export enum SystemOfMeasurement {
  Metric = 'Metric',
  Imperial = 'Imperial',
}
